/** @jsx jsx */
import { jsx } from 'theme-ui'
import { number } from 'prop-types'

const Circle = ({ size = 8, ...props }) => {
  return (
    <div
      sx={{
        height: size,
        width: size,
        borderRadius: size,
        backgroundColor: '#fff',
      }}
      {...props}
    ></div>
  )
}

Circle.propTypes = {
  size: number,
}

export default Circle
